import React from 'react'

function index() {
  return (
    <div>
      <h1>Hi I am product grid</h1>
    </div>
  )
}

export default index
